// (c) chaehongee. Confidential and proprietary.

import { buildApiUrl, http } from './http'
import type { CheckoutSessionResponse } from './billing'

export type PromoCodeAdminItem = {
    id: string
    code: string
    credits: number
    created_by_user_id: string
    valid_until: string
    is_active: boolean
    used_count: number
    created_at: string
    updated_at: string
    redeemed_by_user_id?: string | null
    redeemed_by_email?: string | null
    redeemed_at?: string | null
}

export type PromoCodeListResponse = {
    codes: PromoCodeAdminItem[]
}

export type PromoCodeCreateRequest = {
    credits: number
    code?: string | null
}

export type PromoCodeRedemptionResponse = {
    code: string
    credits_added: number
    credit_balance: number
    redeemed_at: string
}

export async function listPromoCodes(limit = 200): Promise<PromoCodeListResponse> {
    const params = new URLSearchParams({ limit: String(limit) })
    return http<PromoCodeListResponse>(
        buildApiUrl(`/admin/promo-codes?${params.toString()}`),
        { method: 'GET' }
    )
}

export async function createPromoCode(
    payload: PromoCodeCreateRequest
): Promise<PromoCodeAdminItem> {
    return http<PromoCodeAdminItem>(buildApiUrl('/admin/promo-codes'), {
        method: 'POST',
        body: JSON.stringify(payload),
    })
}

export type PrepaidCodeCheckoutRequest = {
    currency: string
    amount: number
    code?: string | null
}

export async function createPrepaidCodeCheckout(
    payload: PrepaidCodeCheckoutRequest
): Promise<CheckoutSessionResponse> {
    return http<CheckoutSessionResponse>(buildApiUrl('/admin/prepaid-codes/checkout'), {
        method: 'POST',
        body: JSON.stringify(payload),
    })
}

export async function redeemPromoCode(code: string): Promise<PromoCodeRedemptionResponse> {
    return http<PromoCodeRedemptionResponse>(buildApiUrl('/promo-codes/redeem'), {
        method: 'POST',
        body: JSON.stringify({ code }),
    })
}
